import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  customers: [],
  selectedCustomer: null,
  currentPage: 1,
  totalPages: 1,
  totalDocuments: 0,
  isCustomerCreated: false,
  loading: false,
  isCustomerCancelled: false,
  isCustomerEdited: false,
  error: null,
};

const customersSlice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    fetchCustomersRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchCustomersSuccess(state, action) {
      state.loading = false;
      state.customers = action.payload.customers;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalDocuments = action.payload.totalDocuments;
    },
    fetchCustomersFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    fetchCustomerById(state) {
      state.loading = true;
      state.error = null;
    },
    fetchCustomerByIdSuccess(state, action) {
      state.loading = false;
      state.selectedCustomer = action.payload;
    },
    fetchCustomerByIdFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    createCustomerRequest(state) {
      state.loading = true;
      state.error = null;
      state.isCustomerCreated = false;
    },
    createCustomerSuccess(state) {
      state.loading = false;
      state.error = false;
      state.isCustomerCreated = true;
    },
    createCustomerFailure(state, action) {
      state.loading = false;
      state.isCustomerCreated = false;
      state.error = action.payload;
    },
    editCustomerRequest(state) {
      state.loading = true;
      state.error = null;
      state.isCustomerEdited = false;
    },
    editCustomerFailure(state, action) {
      state.loading = false;
      state.isBCustomerEdited = false;
      state.error = action.payload;
    },
    editCustomerSuccess(state) {
      state.loading = false;
      state.error = null;
      state.isCustomerEdited = true;
    },
    cancelCustomerCreate(state) {
      state.loading = false;
      state.error = null;
      state.isCustomerCreated = false;
    },
    markCustomerCreated(state, action) {
      state.isCustomerCreated = action.payload;
    },
    markCustomerEdited(state, action) {
      state.isCustomerEdited = action.payload;
    },
    resetSelectedCustomer(state) {
      state.selectedCustomer = null;
    },
  },
});

export const {
  fetchCustomersRequest,
  fetchCustomersSuccess,
  fetchCustomersFailure,
  fetchCustomerById,
  fetchCustomerByIdSuccess,
  fetchCustomerByIdFailure,
  createCustomerRequest,
  createCustomerSuccess,
  createCustomerFailure,
  editCustomerRequest,
  editCustomerFailure,
  editCustomerSuccess,
  markCustomerCreated,
  markCustomerEdited,
  cancelCustomerCreate,
  resetSelectedCustomer,
} = customersSlice.actions;

export default customersSlice.reducer;
